import React, { Component } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { SelectBox, Template } from "devextreme-react";
import moment from "moment";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getRequestParams } from "../../helpers/globalfunctions.js";
import { DateFormat } from "../../helpers/fixcodes";
import { LoadPanel } from "devextreme-react/load-panel";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton.js";
import LiveTripTracking from "../map/LiveTripTracking";
import TripReplayMap from "../map/TripReplayMap";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
import { stashGridState, popGridState } from "../../helpers/gridStateCache";
const tripStatusTypeList = [
  { id: 0, name: "All Rides" },
  { id: 1, name: "Pending" },
  { id: 2, name: "On Job" },
  { id: 3, name: "Completed" },
  { id: 4, name: "Cancelled" },
];
const DutyTypeLst = [
  { id: 0, name: "All Duty" },
  { id: 1, name: "Fly" },
  { id: 2, name: "Non Fly" },
];
const TimeSlotList = [
  { id: 0, name: "All Time" },
  { id: 1, name: "00:00 - 06:00" },
  { id: 2, name: "06:00 - 12:00" },
  { id: 3, name: "12:00 - 18:00" },
  { id: 4, name: "18:00 - 23:59" },
];
const DATE_RANGE_PRESETS = [
  { label: "Today", getRange: () => [moment(), moment()] },
  {
    label: "Yesterday",
    getRange: () => [moment().subtract(1, "day"), moment().subtract(1, "day")],
  },
  {
    label: "This Week",
    getRange: () => [moment().startOf("week"), moment().endOf("week")],
  },
  {
    label: "Last Week",
    getRange: () => [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "This Month",
    getRange: () => [moment().startOf("month"), moment().endOf("month")],
  },
  {
    label: "Last Month",
    getRange: () => [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
];
// Hoisted to module scope so the CSS string is not rebuilt on every render
const DISPATCH_STYLES = `
          .dc-filter-card {
            background: #ffffff;
            border: none;
            border-radius: 10px;
            box-shadow: 0 2px 12px rgba(142,100,72,0.12);
            padding: 0 !important;
            overflow: hidden;
          }
          .dc-filter-body {
            padding: 0.6rem !important;
          }
          .dc-filter-body label {
            font-size: 0.7rem;
            font-weight: 600;
            color: #8E6448;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 0.2rem;
          }
          .dc-filter-body .dx-texteditor.dx-editor-outlined {
            border: 1px solid #e3d5c6;
            border-radius: 6px;
            background: #fffdfb;
          }
          .dc-filter-body .dx-texteditor.dx-editor-outlined.dx-state-hover {
            border-color: #d9c3aa;
          }
          .dc-filter-body .dx-texteditor.dx-editor-outlined.dx-state-focused,
          .dc-filter-body .dx-texteditor.dx-editor-outlined.dx-state-focused.dx-state-hover {
            border-color: #f4691e;
            box-shadow: none;
          }
          .dc-filter-body .dx-texteditor-input {
            padding-top: 5px;
            padding-bottom: 5px;
            min-height: 29px;
            font-size: 0.8rem;
          }
          .dc-filter-body .replay-date-time .dx-icon {
            color: #c9781e;
          }
          .filter-box {
            margin-bottom: 0px; //0.6rem;
          }
          .dc-filter-row {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            gap: 0.75rem; /* equal row and column gap */
          }
          .dc-filter-field {
            flex: 0 1 310px;
            min-width: 200px;
          }
          .dc-daterange-field {
            /* fixed: just wide enough for "MM/dd/yyyy - MM/dd/yyyy" */
            flex: 0 0 176px;
            min-width: 176px;
          }
          .dc-daterange-wrapper {
            display: block;
            width: 100%;
          }
          .dc-daterange-input {
            display: block;
            width: 100%;
            border: 1px solid #e3d5c6;
            border-radius: 6px;
            background: #fffdfb;
            padding: 5px 9px;
            min-height: 31px;
            font-size: 0.8rem;
            color: #333;
            box-sizing: border-box;
            outline: none;
            transition: border-color 0.15s ease;
          }
          .dc-daterange-input:hover {
            border-color: #d9c3aa;
          }
          .dc-daterange-input:focus {
            border-color: #f4691e;
            box-shadow: none;
          }
          .react-datepicker-popper {
            z-index: 1050;
          }
          .react-datepicker__day--in-range,
          .react-datepicker__day--in-selecting-range,
          .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--keyboard-selected {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--range-start,
          .react-datepicker__day--range-end,
          .react-datepicker__day--selecting-range-start,
          .react-datepicker__day--selecting-range-end,
          .react-datepicker__day--selected {
            background-color: #f4691e;
            color: #ffffff;
          }
          .react-datepicker__header {
            background-color: #fdf7f2;
            border-bottom: 1px solid #e8d5c4;
          }
          .dc-daterange-shell {
            display: flex;
            align-items: stretch;
          }
          .dc-daterange-presets {
            display: flex;
            flex-direction: column;
            gap: 2px;
            padding: 8px 6px;
            background: #fdf7f2;
            border-right: 1px solid #e8d5c4;
            min-width: 112px;
          }
          .dc-preset-btn {
            border: none;
            background: transparent;
            text-align: left;
            padding: 6px 10px;
            font-size: 0.78rem;
            font-weight: 600;
            color: #6b4a2b;
            border-radius: 5px;
            cursor: pointer;
            white-space: nowrap;
            transition: background 0.15s ease, color 0.15s ease;
          }
          .dc-preset-btn:hover {
            background: #f5e7d8;
          }
          .dc-preset-btn.active {
            background: #f4691e;
            color: #ffffff;
          }
          .dc-daterange-months {
            position: relative;
          }
          .dc-filter-radio {
            flex: 0 1 auto;
            min-width: 260px;
          }
          .dc-status-pills {
            display: flex;
            flex-wrap: wrap;
            gap: 0.4rem;
          }
          .dc-status-pill {
            display: inline-flex;
            align-items: center;
            gap: 0.45rem;
            border: none;
            background: #fdf7f2;
            color: #8a6a4a;
            font-size: 0.76rem;
            font-weight: 600;
            letter-spacing: 0.01em;
            padding: 0 0.75rem;
            height: 31px;
            box-sizing: border-box;
            border-radius: 6px;
            white-space: nowrap;
            cursor: pointer;
            outline: none;
            transition: background 0.15s ease, color 0.15s ease;
          }
          .dc-status-pill:focus,
          .dc-status-pill:focus-visible,
          .dc-status-pill:active {
            outline: none;
            box-shadow: none;
          }
          .dc-status-dot {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 2px solid #cdbba5;
            background: #ffffff;
            box-sizing: border-box;
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: border-color 0.15s ease;
          }
          .dc-status-dot::after {
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: transparent;
            transition: background 0.15s ease;
          }
          .dc-status-pill:hover {
            background: #f5e7d8;
            color: #6b4a2b;
          }
          .dc-status-pill.active,
          .dc-status-pill.active:hover {
            background: #e8f5e9;
            color: #2e7d32;
          }
          .dc-status-pill.active .dc-status-dot {
            border-color: #2e7d32;
          }
          .dc-status-pill.active .dc-status-dot::after {
            background: #2e7d32;
          }
          .dc-filter-actions {
            display: flex;
            gap: 0.5rem;
            flex-shrink: 0;
            flex-wrap: wrap;
            white-space: nowrap;
            /* offset equal to the field labels so the button lines up with the inputs */
            padding-top: 27px;
          }
          .dc-filter-actions .btn {
            height: 31px;
            display: inline-flex;
            align-items: center;
            padding-top: 0;
            padding-bottom: 0;
            border-radius: 6px;
            box-sizing: border-box;
          }

          .dc-grid-wrap {
            margin-bottom: 0;
          }
          .dc-grid-wrap > .card-body {
            padding: 0.6rem !important;
          }
          .dc-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .dc-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .dc-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.4rem 0.6rem !important;
          }
        .dx-datagrid-header-panel .dx-toolbar
        {
          margin-bottom: 5px !important
        }
          .dc-grid-subtoolbar {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            justify-content: space-between;
            gap: 0.75rem;
            background: #fdf7f2;
            border: 1px solid #e8d5c4;
            border-bottom: none;
            border-radius: 8px 8px 0 0;
            padding: 0.5rem 0.6rem;
          }
          .dc-grid-subtoolbar-filters {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            gap: 0.75rem;
          }
          .dc-grid-subtoolbar label {
            display: block;
            font-size: 0.7rem;
            font-weight: 600;
            color: #8E6448;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 0.25rem;
          }
          .dc-grid-refresh-btn {
            display: none;
          }

          @media (max-width: 576px) {
            .dc-filter-field,
            .dc-filter-field.dc-daterange-field,
            .dc-filter-radio,
            .dc-filter-actions {
              flex-basis: 100%;
              min-width: 100%;
            }
            .dc-filter-actions {
              justify-content: flex-start;
              padding-top: 0;
            }
          }

          /* ── Live Trip Tracking slide-in panel ──
             Replaces the old TripTrackingMapModal popup: slides in from the
             right over the page instead of opening a dialog. Fixed to the
             viewport (this page has no map/bounding wrapper to anchor an
             absolute panel to, unlike the fleet tracking view). Colours match
             LiveTripMap's own dark/accent-green look so the panel chrome and
             the map dashboard read as one surface. */
          .dc-live-panel {
            position: fixed;
            /* The app shell's own top navbar is fixed at the very top of the
               viewport and paints over anything else sharing that space —
               starting this panel at top:0 put its header (title/close
               button) directly underneath that navbar, hiding both. Offset
               below the navbar's height instead of fighting it with z-index. */
            top: 50px;
            right: 0;
            bottom: 0;
            width: clamp(560px, 60vw, 1000px);
            max-width: 100vw;
            z-index: 1500;
            display: flex;
            flex-direction: column;
            background: #11161c;
            border-left: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: -12px 0 40px rgba(0, 0, 0, 0.45);
            animation: dc-live-panel-in 0.28s ease;
          }
          @keyframes dc-live-panel-in {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
          .dc-live-panel-header {
            position: relative;
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 14px 44px 14px 18px;
            background: linear-gradient(135deg, #16211c 0%, #1a2b22 60%, #163024 100%);
            border-bottom: 1px solid rgba(62, 224, 163, 0.25);
            color: #eafff6;
            font-size: 15px;
            font-weight: 600;
            flex-shrink: 0;
            z-index: 50;
          }
          .dc-live-panel-close {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 32px;
            height: 32px;
            border-radius: 8px;
            border: none;
            background: rgba(255, 255, 255, 0.12);
            color: #eafff6;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            flex-shrink: 0;
            z-index: 51;
            transition: background 0.15s ease, color 0.15s ease;
          }
          .dc-live-panel-close:hover {
            background: rgba(255, 90, 90, 0.18);
            color: #ff8a8a;
          }
          .dc-live-panel-body {
            flex: 1;
            min-height: 0;
            overflow: hidden;
          }
          .dc-live-panel-map {
            height: 100%;
          }
          @media (max-width: 640px) {
            .dc-live-panel { width: 100vw; }
          }

          /* TripReplayMap is its own dark dashboard (with its own header/close
             button and map/cards), not the compact LiveTripMap, so it needs
             much more room than the default .dc-live-panel width to be usable.
             It also renders its own header, so .dc-live-panel's padding/flex
             body wrapper is unused for this panel — TripReplayMap fills the
             whole panel directly. */
          .dc-replay-panel {
            width: clamp(760px, 85vw, 1400px);
          }
          @media (max-width: 640px) {
            .dc-replay-panel { width: 100vw; }
          }
        `;
export class DispatchComponent extends Component {
  static displayName = DispatchComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      isFilterSubmitted: false,
      isAirlineRideApiLoading: false,
      isToolbarRefreshing: false,
      loadPanelVisible: false,
      filterFromDatetime: new Date(),
      filterToDatetime: moment(new Date()).format("MM/DD/YYYY") + " 23:59:59",
      filterDropdownAirportDataSource: [],
      airportCode: "",
      tripStatusTypeId: 0,
      tripLst: [],
      tripGridDataSource: [],
      activityTypeId: 0,
      dutyTypeId: 0,
      timeSlotId: 0,
      reservationTitle: "Crew Transfers ",
      locateVehicleMap: {
        openModal: false,
        transactionId: "",
        airlineCode: "",
        employeeNumber: "",
        vehicleNo: "",
      },
      replayVehicleMap: {
        openModal: false,
        ride: null,
      },
    };
    this.refDataGrid = React.createRef();
    this.refDateRangePicker = React.createRef();
  }
  applyDateRangePreset = (preset) => {
    try {
      const [start, end] = preset.getRange();
      this.setState((prev) => ({
        ...prev,
        filterFromDatetime: start.toDate(),
        filterToDatetime: end.toDate(),
      }));
      if (this.refDateRangePicker.current) {
        this.refDateRangePicker.current.setOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  isDateRangePresetActive = (preset) => {
    const [start, end] = preset.getRange();
    return (
      this.state.filterFromDatetime &&
      this.state.filterToDatetime &&
      start.isSame(this.state.filterFromDatetime, "day") &&
      end.isSame(this.state.filterToDatetime, "day")
    );
  };
  renderDateRangeCalendarContainer = ({ className, children }) => {
    return (
      <CalendarContainer className={className}>
        <div className="dc-daterange-shell">
          <div className="dc-daterange-presets">
            {DATE_RANGE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`dc-preset-btn${
                  this.isDateRangePresetActive(preset) ? " active" : ""
                }`}
                onClick={() => this.applyDateRangePreset(preset)}
              >
                {preset.label}
              </button>
            ))}
          </div>
          <div className="dc-daterange-months">{children}</div>
        </div>
      </CalendarContainer>
    );
  };
  componentDidMount() {
    try {
      document.querySelector("#lblPageTitle").innerHTML = `Crew Transfer`;
      // Returning from crew-activity-mobile's Back button stashes this grid's own
      // previous state in an in-memory cache (not router state — too big for
      // history.pushState) — restore it directly instead of refetching everything.
      const cachedState = popGridState();
      if (cachedState) {
        this.setState(cachedState);
      } else {
        this.fetGridDataOnPageLoad();
      }
    } catch (error) {
      console.log(error);
    }
  }
  closeLocateVehiclePanel = () => {
    this.setState(
      (prev) => ({
        ...prev,
        locateVehicleMap: {
          openModal: false,
          transactionId: "",
          airlineCode: "",
          employeeNumber: "",
          vehicleNo: "",
        },
      }),
      this.resizeDataGridColumns,
    );
  };
  fetGridDataOnPageLoad = async () => {
    try {
      this.setState((prev) => ({ ...prev, isAirlineRideApiLoading: true }));
      await Promise.all([this.getAirports(), this.getTrips()]);
      this.setState((prev) => ({ ...prev, isAirlineRideApiLoading: false }));
    } catch (error) {
      console.log(error);
    }
  };
  getAirports = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const response = await axiosGet(
        `Airport/get-airport-dropdown/${airlineCode}`,
      );
      this.setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: response?.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAirports function",
        err,
      );
    }
  };
  getTrips = async () => {
    try {
      let filterFromDatetime = moment(this.state.filterFromDatetime).startOf(
        "day",
      );
      // Range picker leaves the end date null until the second click —
      // fall back to a single-day range in that case
      let filterToDatetime = moment(
        this.state.filterToDatetime ?? this.state.filterFromDatetime,
      ).endOf("day");
      this.setState((prev) => ({
        ...prev,
        filterFromDatetime: filterFromDatetime,
        filterToDatetime: filterToDatetime,
      }));
      const res = await axiosPost(`Rides/get-rides`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
        StatusId: this.state.tripStatusTypeId,
        FromDate: moment(filterFromDatetime).format(`YYYY-MM-DD HH:mm:ss`),
        ToDate: moment(filterToDatetime).format(`YYYY-MM-DD HH:mm:ss`),
        AirportCode: this.state.airportCode,
      });
      const data = res?.payload ?? [];
      let tripLst = data?.filter((f) => f.tripStatusId !== 118) ?? [];
      // tripLst = [
      //   ...new Set(
      //     tripLst?.map((item, index) => ({
      //       ...item,
      //       id: index + 1,
      //     }))
      //   ),
      // ];
      this.setState((prev) => ({
        ...prev,
        isAirlineRideApiLoading: false,
        tripLst: tripLst,
      }));
      this.filterTripDataGridDutyTypeWise(
        this.state.dutyTypeId,
        this.state.timeSlotId,
        tripLst,
      );
    } catch (error) {
      console.log("Error in " + this.displayName + ".getTrips function", error);
    }
  };
  handleToolbarRefresh = async () => {
    try {
      this.setState((prev) => ({ ...prev, isToolbarRefreshing: true }));
      await this.getTrips();
    } catch (error) {
      console.log(error);
    } finally {
      this.setState((prev) => ({ ...prev, isToolbarRefreshing: false }));
    }
  };
  filterTripDataGridDutyTypeWise = (dutyTypeId, timeSlotId, tripLst) => {
    try {
      const tripGridDataSource =
        tripLst?.filter((f) => {
          const dutyMatch =
            dutyTypeId === 0 ||
            (dutyTypeId === 1 &&
              (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
            (dutyTypeId === 2 && f.activityTypeId === 2);

          let timeMatch = true;
          if (timeSlotId > 0 && f.pickupTime) {
            const d = new Date(f.pickupTime);
            const mins = d.getHours() * 60 + d.getMinutes();
            if (timeSlotId === 1) timeMatch = mins < 360;
            else if (timeSlotId === 2) timeMatch = mins >= 360 && mins < 720;
            else if (timeSlotId === 3) timeMatch = mins >= 720 && mins < 1080;
            else if (timeSlotId === 4) timeMatch = mins >= 1080;
          }

          return dutyMatch && timeMatch;
        }) ?? [];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: tripGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  resizeDataGridColumns = () => {
    setTimeout(() => {
      if (this.refDataGrid.current && this.refDataGrid.current.instance) {
        this.refDataGrid.current.instance.updateDimensions();
      }
    }, 0);
  };
  renderGridCell = (data) => {
    let showReplay =
      data.data.tripStatusId === 116 &&
      data.data.locationTime &&
      data.data.completedTime &&
      data.data.vehicleId;
    let locateVehicle = data.data.isOnJob && (
      <a
        title="Live Tracking"
        onClick={(e) => {
          e.preventDefault();
          try {
            // The grid recalculates its (columnAutoWidth) column sizes
            // whenever this component re-renders while the panel opens —
            // previously only visible after closing (the old modal covered
            // the grid entirely while open, so nobody saw it shrink). The
            // slide-in panel leaves the grid visible, so force the same
            // corrective resize on open too, not just on close.
            this.setState(
              (prev) => ({
                ...prev,
                locateVehicleMap: {
                  openModal: true,
                  transactionId: data.data.transactionId,
                  airlineCode: data.data.airlineCode,
                  employeeNumber: data.data.employeeNo,
                  vehicleNo: data.data.vehicleNo,
                },
              }),
              this.resizeDataGridColumns,
            );
          } catch (error) {
            console.log(error);
          }
        }}
      >
        <i
          style={{ cursor: "pointer" }}
          className="fas fa-satellite-dish fa-lg btn-link"
        />
      </a>
    );
    let replayVehicle = showReplay && (
      <a
        title="Replay Vehicle"
        onClick={(e) => {
          e.preventDefault();
          try {
            this.setState(
              (prev) => ({
                ...prev,
                replayVehicleMap: {
                  openModal: true,
                  ride: data.data,
                },
              }),
              this.resizeDataGridColumns,
            );
          } catch (error) {
            console.log(error);
          }
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${locateVehicle ? "8px" : "3px"}`,
          }}
          className="fas fa-play-circle fa-lg btn-link"
        />
      </a>
    );
    // open the crew-activity-mobile view for this row's staff
    let mobileViewLink = data?.data?.employeeNo && (
      <a
        href="#"
        title="Open Crew Activity view"
        onClick={(e) => {
          e.preventDefault();
          stashGridState(this.state);
          this.props.history.push("/crew-activity-mobile", {
            employeeNumber: data.data.employeeNo,
            sourceUrl: "/dispatch",
          });
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${locateVehicle || replayVehicle ? "8px" : "3px"}`,
          }}
          className="fas fa-mobile-alt fa-lg"
        />
      </a>
    );

    return (
      <div style={{ textAlign: "left" }}>
        {locateVehicle}
        {replayVehicle}
        {mobileViewLink}
      </div>
    );
  };

  onRowPrepared = (e) => {
    if (e.rowType === "header") {
      e.rowElement.style.backgroundColor = "#fff0e6";
      e.rowElement.style.color = "#000000";
    }
    if (e.rowType === "data") {
      if (e.data.tripStatusId === 101) {
        e.rowElement.style.backgroundColor = "#fffaf6";
        e.rowElement.style.color = "#3d1f00";
        if (e.data.activityTypeId === 2) {
          e.rowElement.style.backgroundColor = "#fdf0e4";
          e.rowElement.style.color = "#5c3a1e";
        }
      } else if (e.data.tripStatusId === 111) {
        e.rowElement.style.backgroundColor = "#f0ebe6";
        e.rowElement.style.color = "#8a7060";
      } else if (e.data.tripStatusId === 104) {
        e.rowElement.style.backgroundColor = "#fff4cc";
        e.rowElement.style.color = "#6b4e00";
      } else if (e.data.tripStatusId === 103 || e.data.tripStatusId === 105) {
        e.rowElement.style.backgroundColor = "#f5ede4";
        e.rowElement.style.color = "#5c3a1e";
      } else if (e.data.tripStatusId === 107) {
        e.rowElement.style.backgroundColor = "#fff0a0";
        e.rowElement.style.color = "#5a4000";
      } else if (e.data.tripStatusId === 108) {
        e.rowElement.style.backgroundColor = "#e6f4ea";
        e.rowElement.style.color = "#1e5631";
      } else if (e.data.tripStatusId === 109 || e.data.tripStatusId === 110) {
        e.rowElement.style.backgroundColor = "#f0e8fb";
        e.rowElement.style.color = "#4a1a6e";
      } else if (e.data.tripStatusId === 116) {
        e.rowElement.style.backgroundColor = "#c8f0d4";
        e.rowElement.style.color = "#0d3b1f";
      }
    }
  };

  render() {
    return (
      <>
        <style>{DISPATCH_STYLES}</style>

        <div className="filter-box">
          <div className="card dc-filter-card p-0 m-0">
            <div className="dc-filter-body">
              <div className="dc-filter-row">
                <div className="dc-filter-field dc-daterange-field">
                  <div className="form-group mb-0">
                    <label>From - To Date</label>
                    <ReactDatePicker
                      ref={this.refDateRangePicker}
                      calendarContainer={this.renderDateRangeCalendarContainer}
                      selectsRange={true}
                      startDate={
                        this.state.filterFromDatetime
                          ? moment(this.state.filterFromDatetime).toDate()
                          : null
                      }
                      endDate={
                        this.state.filterToDatetime
                          ? moment(this.state.filterToDatetime).toDate()
                          : null
                      }
                      onChange={([start, end]) => {
                        this.setState((prev) => ({
                          ...prev,
                          filterFromDatetime: start,
                          filterToDatetime: end,
                        }));
                      }}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/dd/yyyy - MM/dd/yyyy"
                      onChangeRaw={(e) => e.preventDefault()}
                      className="dc-daterange-input"
                      wrapperClassName="dc-daterange-wrapper"
                      monthsShown={2}
                      showPopperArrow={false}
                      portalId="dc-daterange-portal"
                    />
                  </div>
                </div>
                <div className="dc-filter-field">
                  <div className="form-group mb-0">
                    <label>Airport(s)</label>
                    <SelectBox
                      dataSource={this.state.filterDropdownAirportDataSource}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="All Airports"
                      value={this.state.airportCode}
                      displayExpr="airportName"
                      valueExpr="airportCode"
                      showClearButton={true}
                      searchEnabled={true}
                      onValueChanged={(e) => {
                        this.setState((prev) => ({
                          ...prev,
                          airportCode: e.value ?? "",
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className="dc-filter-radio">
                  <div className="form-group mb-0">
                    <label>Trip Status</label>
                    <div className="dc-status-pills">
                      {tripStatusTypeList.map((item) => (
                        <button
                          key={item.id}
                          type="button"
                          className={`dc-status-pill${
                            this.state.tripStatusTypeId === item.id
                              ? " active"
                              : ""
                          }`}
                          onClick={() => {
                            this.setState((prev) => ({
                              ...prev,
                              tripStatusTypeId: item.id,
                            }));
                          }}
                        >
                          <span className="dc-status-dot" />
                          {item.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="dc-filter-actions">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={async () => {
                      try {
                        this.setState((prev) => ({
                          ...prev,
                          isFilterSubmitted: true,
                          isAirlineRideApiLoading: true,
                        }));
                        await this.getTrips();
                        this.setState((prev) => ({
                          ...prev,
                          isFilterSubmitted: false,
                          isAirlineRideApiLoading: false,
                        }));
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <span title="Search">
                      <i
                        className={`fas fa-${
                          this.state.isFilterSubmitted
                            ? "spinner fa-spin"
                            : "search"
                        }`}
                      ></i>
                      &nbsp;Search
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end filter-box */}

        <div className="card dc-grid-wrap">
          <div className="card-body">
            {this.state.isAirlineRideApiLoading && (
              <DataGridSkeletonPageSimpleWithTitle />
            )}
            {!this.state.isAirlineRideApiLoading && (
              <>
                <div className="dc-grid-subtoolbar">
                  <div className="dc-grid-subtoolbar-filters">
                    <div className="form-group mb-0">
                      <label>Duty Type</label>
                      <SelectBox
                        dataSource={DutyTypeLst}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select duty type"
                        name="dutyTypeDropdown"
                        width={170}
                        defaultValue={0}
                        value={this.state.dutyTypeId}
                        displayExpr="name"
                        valueExpr="id"
                        onValueChanged={(e) => {
                          try {
                            let dutyTypeId = e.value ?? 0;
                            this.setState((prev) => ({
                              ...prev,
                              dutyTypeId: dutyTypeId,
                            }));
                            this.filterTripDataGridDutyTypeWise(
                              dutyTypeId,
                              this.state.timeSlotId,
                              this.state.tripLst,
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        showClearButton={true}
                        searchEnabled={true}
                      />
                    </div>
                    <div className="form-group mb-0">
                      <label>Time Slot</label>
                      <SelectBox
                        dataSource={TimeSlotList}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="All Time"
                        name="timeSlotDropdown"
                        width={165}
                        defaultValue={0}
                        value={this.state.timeSlotId}
                        displayExpr="name"
                        valueExpr="id"
                        onValueChanged={(e) => {
                          try {
                            const timeSlotId = e.value ?? 0;
                            this.setState((prev) => ({
                              ...prev,
                              timeSlotId: timeSlotId,
                            }));
                            this.filterTripDataGridDutyTypeWise(
                              this.state.dutyTypeId,
                              timeSlotId,
                              this.state.tripLst,
                            );
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        showClearButton={true}
                        searchEnabled={false}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm dc-grid-refresh-btn"
                    title="Refresh"
                    disabled={this.state.isToolbarRefreshing}
                    onClick={this.handleToolbarRefresh}
                  >
                    <i
                      className={`fas fa-${this.state.isToolbarRefreshing ? "spinner fa-spin" : "sync-alt"}`}
                    />
                  </button>
                </div>
                <DataGrid
                  ref={this.refDataGrid}
                  dataSource={this.state.tripGridDataSource}
                  columnAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  repaintChangesOnly={true}
                  onRowPrepared={this.onRowPrepared}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarDataFilterTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="rideId"
                    caption=""
                    allowSorting={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowFiltering={false}
                    cellRender={this.renderGridCell}
                    fixed={true}
                    minWidth={35}
                    width={"auto"}
                  />
                  <Column
                    dataField="rideId"
                    caption="Ride Id #"
                    allowSearch={true}
                    dataType={"string"}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="activityType"
                    caption="Duty Type"
                    allowFiltering={true}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="activityDisplay"
                    caption="Activity/Flight Number"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={180}
                    cellRender={(data) => {
                      if (data.data?.activityLocationCode) {
                        return (
                          <div className="mergeData ellipsis">
                            <span className="text-muted">
                              <i className="fas fa-map-marker-alt fa-xs" />
                            </span>{" "}
                            {`${data.data?.activityCode ?? ""}`}
                            <br />
                            <span className="text-muted">
                              <i className="fas fa-building fa-xs"></i>
                            </span>{" "}
                            {`${data.data?.activityLocationCode ?? ""}`}
                          </div>
                        );
                      }
                      return (
                        <div className="mergeData ellipsis">
                          <span className="text-muted">
                            <i className="fas fa-plane-departure"></i>
                          </span>{" "}
                          <span>{data.data.activityDisplay}</span>
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="employeeNo"
                    caption="Staff ID #"
                    dataType={"string"}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="paxName"
                    caption="Staff Name"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="paxMobileNo"
                    caption="Staff Mobile"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  {/* <Column
                    dataField="crewPosition"
                    caption="Staff Type"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    alignment={"center"}
                  /> */}
                  <Column
                    dataField="crewRank"
                    caption="Staff Rank"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    alignment={"center"}
                  />
                  <Column
                    dataField="transporterName"
                    caption="Service Provider"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="pickupLocation"
                    caption="Pick-up"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={200}
                  />
                  <Column
                    dataField="dropoffLocation"
                    caption="Drop-off"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={200}
                  />
                  <Column
                    dataField="flightTime"
                    caption="Flight Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="flightTerminal"
                    caption="Terminal"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="flightATA"
                    caption="Flight Actual Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="pickupTime"
                    caption="Pickup Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="dutyReportingTime"
                    caption="Reporting Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="deBriefingTime"
                    caption="DeBriefing Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />

                  <Column
                    dataField="vehicleNo"
                    caption="Vehicle"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="driverName"
                    caption="Driver"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="tripStatus"
                    caption="Ride Status"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="assignedStatus"
                    caption="Assigned Status"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="boardingOtp"
                    caption="Boarding Otp"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType={"string"}
                    alignment={"center"}
                  />
                  <Column
                    dataField="otpVerifiedStatus"
                    caption="OTP Verify Status"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="clubbedStatus"
                    caption="Clubbing Status"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />

                  <Column
                    dataField="assignedTime"
                    caption="Assigned Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="locationTime"
                    caption="On Location"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="loadTime"
                    caption="Boarded"
                    allowSorting={true}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="unloadTime"
                    caption="Reached"
                    allowSorting={true}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="completedTime"
                    caption="Completed"
                    allowSorting={true}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Column
                    dataField="activityStartTime"
                    caption="Activity Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType="datetime"
                    format={DateFormat.DisplayDateTime24NorthFormat}
                  />
                  <Template
                    name="toolbarDataFilterTemplate"
                    render={() => {
                      return (
                        <>
                          <span>
                            <i className={`fas fa-clock`}></i>{" "}
                            {this.state.reservationTitle}
                            <span className="ml-2">
                              [{" "}
                              {moment(this.state.filterFromDatetime).format(
                                `DD/MM/yyyy HH:mm`,
                              )}
                              {" - "}
                              {moment(
                                this.state.filterToDatetime ??
                                  this.state.filterFromDatetime,
                              ).format(`DD/MM/yyyy HH:mm`)}{" "}
                              ]
                            </span>
                          </span>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={true} />
                  <Paging defaultPageSize={10} />
                  <Pager
                    displayMode="compact"
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="CrewActivity"
                  />
                </DataGrid>
              </>
            )}
          </div>
        </div>
        {this.state.locateVehicleMap.openModal && (
          <div className="dc-live-panel">
            <div className="dc-live-panel-header">
              <span>
                Live Trip Tracking
                {this.state.locateVehicleMap.vehicleNo
                  ? ` · ${this.state.locateVehicleMap.vehicleNo}`
                  : ""}
              </span>
              <button
                type="button"
                className="dc-live-panel-close"
                aria-label="Close"
                onClick={this.closeLocateVehiclePanel}
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="dc-live-panel-body">
              <LiveTripTracking
                key={this.state.locateVehicleMap.transactionId}
                airlineCode={this.state.locateVehicleMap.airlineCode}
                transactionId={this.state.locateVehicleMap.transactionId}
                employeeNumber={this.state.locateVehicleMap.employeeNumber}
                height="100%"
                className="dc-live-panel-map"
                onDeparted={this.closeLocateVehiclePanel}
              />
            </div>
          </div>
        )}
        {this.state.replayVehicleMap.openModal && (
          <div className="dc-live-panel dc-replay-panel">
            <TripReplayMap
              key={this.state.replayVehicleMap.ride?.rideId}
              ride={this.state.replayVehicleMap.ride}
              onClose={() =>
                this.setState(
                  (prev) => ({
                    ...prev,
                    replayVehicleMap: { openModal: false, ride: null },
                  }),
                  this.resizeDataGridColumns,
                )
              }
              height="100%"
            />
          </div>
        )}

        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={{ of: "#historydiv" }}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
